import { useEffect, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

/**
 * Portals its children into the app header's right-side action slot
 * (`#app-header-actions`, rendered by PageLayout just before the global action
 * buttons like Invitation code / Feedback). Lets a route inject a compact
 * header control — e.g. the patient "Requiring action" indicator — into the
 * global header without prop-drilling through the layout. Renders nothing until
 * the slot node exists.
 */
export const HeaderActionsPortal = ({ children }: { children: ReactNode }) => {
  const [node, setNode] = useState<HTMLElement | null>(null);
  useEffect(() => {
    setNode(document.getElementById('app-header-actions'));
  }, []);
  return node ? createPortal(children, node) : null;
};
